export enum TabPanelDisplayMode {
  none = 0,
  smallVertical = 1,
  largeVertical = 2,
  horizontal = 3,
  mediumVertical = 4,
  horizontalCard = 5,
  horizontalPill = 6
}
